import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  OverDriveItem,
  OverDrivePlaceHold,
  PlaceHold,
  OverDriveService,
} from './overdrive/overdrive.service';
import { IHooplaItem, HooplaService } from './hoopla/hoopla.service';

export const ResponseMessages = {
  EARLY_RETURN_SUCCESS: 'Your request to return this item was successfully completed.',
  EARLY_RETURN_ERROR: 'Unable to return selected item. Please Try again later.',
  LOCK_FORMAT_SUCCESS:
    'Your request to download has been accepted. Please proceed to download this item.',
  LOCK_FORMAT_ERROR: 'Unable to select the specified format. Please try again later.',
  PLACE_HOLD_SUCCESS: 'Hold placed successfully.',
  PLACE_HOLD_ERROR: 'Unable to place item on hold. Please try again later.',
  GET_ITEM_ERROR: 'Error loading item. Please try again later.',
  GENERIC_ERROR: 'An error has occured. Please try again later.',
  CANCEL_SUCCESS: 'Hold cancelled.',
  CANCEL_ERROR: 'Unable to cancel hold, please try again later.',
  CHECKOUT_ERROR: 'Unable to checkout, please try again later.',
};
@Injectable({
  providedIn: 'root',
})
export class EContentService {
  constructor(
    private _overDriveService: OverDriveService,
    private _hooplaService: HooplaService,
  ) {}

  overDriveEarlyReturn(id: string): Observable<void> {
    return this._overDriveService.earlyReturn(id);
  }

  overDriveRequestItem(id: string): Observable<OverDriveItem> {
    return this._overDriveService.getItem(id);
  }

  overDriveCheckOut(id: string): Observable<string> {
    return this._overDriveService.checkout(id);
  }

  overDriveGetDownloadLink(uri: string): Observable<string> {
    return this._overDriveService.getDownloadLink(uri);
  }

  overDrivePlaceHold(request: PlaceHold): Observable<OverDrivePlaceHold> {
    return this._overDriveService.placeHold(request);
  }

  overDriveCancelHold(productId: string): Observable<void> {
    return this._overDriveService.cancelHold(productId);
  }

  hooplaItemRequest(id: string): Observable<IHooplaItem> {
    return this._hooplaService.getItem(id);
  }

  hooplaPlaceHold(contentId: number): Observable<void> {
    return this._hooplaService.placeHold(contentId);
  }

  hooplaCancelHold(contentId: number): Observable<void> {
    return this._hooplaService.cancelHold(contentId);
  }

  hooplaCheckout(id: number): Observable<IHooplaItem> {
    return this._hooplaService.checkout(id);
  }

  hooplaReturnTitle(id: number): Observable<void> {
    return this._hooplaService.earlyReturn(id);
  }
}
